// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleWithActions_title__1TjSy","actions":"TitleWithActions_actions__2_NdK","action":"TitleWithActions_action__Wo7yA"};